"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.addLoaderHook = exports.isLoaderHolder = exports.getPostConstructorMethodName = exports.isPromise = exports.arrayEquals = void 0;
var metadata_keys_1 = require("../metadata/metadata-keys");
var metadata_handler_1 = require("../metadata/metadata-handler");
var loader_base_1 = require("./loader-base");
var transient_service_1 = require("./transient-service");
/**
 * 使用自定义方法比较两个数组是否相等
 * @param one
 * @param other
 * @param itemEquals
 */
function arrayEquals(one, other, itemEquals) {
    if (itemEquals === void 0) { itemEquals = function (a, b) { return a === b; }; }
    if (one === other) {
        return true;
    }
    if (!one || !other) {
        return false;
    }
    if (one.length !== other.length) {
        return false;
    }
    for (var i = 0, len = one.length; i < len; i++) {
        if (!itemEquals(one[i], other[i])) {
            return false;
        }
    }
    return true;
}
exports.arrayEquals = arrayEquals;
function isPromise(object) {
    var isObjectOrFunction = (typeof object === 'object' && object !== null) || typeof object === 'function';
    return isObjectOrFunction && typeof object.then === 'function';
}
exports.isPromise = isPromise;
/**
   * 获取目标的postConstructor钩子函数名称
   * @param target
   * @returns
   */
function getPostConstructorMethodName(target) {
    var methodNameMeta = metadata_handler_1.MetadataHandler.getMethodMetadata(metadata_keys_1.POST_CONSTRUCTOR, target);
    if (!methodNameMeta) {
        return undefined;
    }
    return methodNameMeta.methodName;
}
exports.getPostConstructorMethodName = getPostConstructorMethodName;
function isLoaderHolder(instance) {
    if (instance instanceof loader_base_1.LoaderBase || instance instanceof transient_service_1.TransientServiceHolder) {
        return true;
    }
    return false;
}
exports.isLoaderHolder = isLoaderHolder;
function addLoaderHook(instance, hookPoint, callback) {
    if (instance instanceof loader_base_1.LoaderBase || instance instanceof transient_service_1.TransientServiceHolder) {
        instance.addHook(hookPoint, callback);
    }
}
exports.addLoaderHook = addLoaderHook;
//# sourceMappingURL=util.js.map